import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';

type Testimonial = {
  id: number;
  name: string;
  role?: string;
  company?: string;
  image: string;
  quote: string;
};

const Testimonials: React.FC = () => {
  const testimonials: Testimonial[] = [
    {
      id: 1,
      name: 'Johnathon S.',
      image: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=600',
      quote: 'I initially heard about Detailing Growth through an industry friend, Jamie Werner. The impact of their digital marketing services on my business has been positive and motivating. I would absolutely recommend Detailing Growth to others in the detailing, PPF, and window tint industry. The team has been upfront in every way, prompt at answering questions, and quick to provide assistance.'
    },
    {
      id: 2,
      name: 'Cloie Ratliff',
      image: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=600',
      quote: 'The entire team at Detailing growth not only do what they say and say what they do, but they also go above and beyond the call of duty! They have helped protect our business from hackers and assisted me in the early morning hours or even late at night. They work 24/7 to keep our business on top! These guys truly have morals and values that align with the way we conduct our business! Well done!'
    },
    {
      id: 3,
      name: 'Mickey Killian',
      image: 'https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=600',
      quote: 'I found Detailing Growth on Facebook and started listening to Gabe\'s podcast. Since then, my experience with their digital marketing services has been really solid. The leads from Google Ads and Facebook always seem to close really well! They are always on point with telling us what\'s going on, providing us with weekly updates on our marketing. No other agency that does marketing for PPF shops is anywhere near this communicative. I highly recommend Detailing Growth to other businesses in the detailing, PPF, and window tint industry.'
    },
    {
      id: 4,
      name: 'Barry Kimbrell',
      image: 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=600',
      quote: 'Detailing growth is the best company that has ever helped us. I am so thankful for Tyler, Gabe and their team. They are great. I\'ve been in a bad situation with our shops for months and the lead generation system they have helped with has gotten us through the worst winter we\'ve ever experienced. We Definitely look forward to keeping this marriage with them so we can build an empire in Northern California.'
    },
    {
      id: 5,
      name: 'Dalton Tyree',
      image: 'https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=600',
      quote: 'These guys are truly professional with exceptional communication. They focus on what you actually need rather than just what makes them money. They evaluated our authentic needs from a holistic perspective and tailored our marketing strategy perfectly. Choosing to work with them was a quick decision - if you\'re seeking to grow holistically, their services are a must.'
    },
    {
      id: 6,
      name: 'Carlos Viquez',
      image: 'https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=600',
      quote: 'My experience with Detailing Growth was nothing but amazing. Communication was on point, the team was always ready if changes needed to happen quickly. I couldn\'t ask for a better company to work with than these guys. If you need guidance or get pointed into the right direction hook up with Detailing Growth ASAP!'
    },
    {
      id: 7,
      name: 'Aiden Quirini',
      image: 'https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=600',
      quote: 'We had a very useful conversation. Gabe was honest tactical got to the point and provided what I needed to hear. It\'s clear he knows Both shorthand long-term strategies to get you out of a slow growth situation. Money well spent would do again'
    },
    {
      id: 8,
      name: 'JP DeJesus',
      image: 'https://images.pexels.com/photos/874158/pexels-photo-874158.jpeg?auto=compress&cs=tinysrgb&w=600',
      quote: 'Working with Gabe, Tyler, and the team at Detailing Growth has been a fantastic experience. They built a high-performing website that boosted our local rankings significantly. Their expertise extends beyond just marketing; they are knowledgeable in all aspects of business scaling. The communication and support have been excellent, with quick responses whenever we need assistance or insight. I would highly recommend Detailing Growth to others in the detailing, PPF, or window tint industry.'
    },
    {
      id: 9,
      name: 'Robert Winters',
      image: 'https://images.pexels.com/photos/937481/pexels-photo-937481.jpeg?auto=compress&cs=tinysrgb&w=600',
      quote: 'Working with Detailing Growth has transformed my business completely. We\'ve seen 900% growth in just one year and are now on pace to be a $1.2M shop. I\'ve grown from one employee to EIGHT, have more time for myself and family, and they\'ve helped with every aspect of scaling. The best decision I made as an owner was partnering with them - they\'ve helped me transition from working in my business to working on it.'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };

  const testimonialVariants = {
    enter: (direction: number) => ({
      x: direction > 0 ? '100%' : '-100%',
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      x: direction < 0 ? '100%' : '-100%',
      opacity: 0
    })
  };

  const [direction, setDirection] = useState(0);

  const handleNext = () => {
    setDirection(1);
    nextTestimonial();
  };

  const handlePrev = () => {
    setDirection(-1);
    prevTestimonial();
  };

  return (
    <section id="testimonials" className="py-20 bg-gradient-to-b from-background to-background/95 relative overflow-hidden">
      {/* Background gradient */}
      <motion.div 
        className="gradient-overlay w-[600px] h-[600px] top-0 left-[20%]"
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 0.5, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      />
      
      <div className="container mx-auto px-4">
        <motion.div 
          className="text-center mb-16 max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <motion.span 
            className="px-3 py-1 rounded-full bg-accent/10 border border-accent/20 text-accent font-semibold text-sm inline-block mb-4"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Success Stories
          </motion.span>
          <h2 className="text-3xl md:text-4xl font-extrabold mb-6">What Our Customers Are Saying</h2>
          <p className="text-white/70 text-lg">Join the thousands of detailing professionals who have transformed their businesses with DetailerOS coaching and GRIT SUITE technology.</p>
        </motion.div>
        
        <div className="max-w-4xl mx-auto relative">
          {/* Navigation arrows - now positioned completely outside the card */}
          <div className="flex justify-between absolute w-full top-1/2 -translate-y-1/2 px-2 md:px-0 left-0 right-0 pointer-events-none" style={{ width: "calc(100% + 80px)", left: "-40px" }}>
            <motion.button
              className="pointer-events-auto w-10 h-10 rounded-full bg-background/70 backdrop-blur-sm flex items-center justify-center hover:bg-accent hover:text-background shadow-lg z-20"
              onClick={handlePrev}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <ChevronLeft size={20} />
            </motion.button>
            
            <motion.button
              className="pointer-events-auto w-10 h-10 rounded-full bg-background/70 backdrop-blur-sm flex items-center justify-center hover:bg-accent hover:text-background shadow-lg z-20"
              onClick={handleNext}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <ChevronRight size={20} />
            </motion.button>
          </div>
          
          {/* Fixed the testimonial container to ensure visibility on mobile */}
          <div className="relative min-h-[300px] sm:min-h-[280px] md:min-h-[350px] rounded-2xl overflow-hidden glassmorphic">
            <AnimatePresence initial={false} custom={direction}>
              <motion.div
                key={currentIndex}
                custom={direction}
                variants={testimonialVariants}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{ duration: 0.5, ease: "easeInOut" }}
                className="p-6 sm:p-8 md:p-12 flex flex-col justify-center h-full absolute inset-0"
              >
                <div className="flex items-center space-x-1 mb-4 md:mb-6">
                  {[1, 2, 3, 4, 5].map(star => (
                    <Star key={star} size={16} className="fill-accent text-accent" />
                  ))}
                </div>
                
                <p className="text-md sm:text-lg md:text-xl italic mb-6 md:mb-8 text-white/90">"{testimonials[currentIndex].quote}"</p>
                
                <div className="flex items-center mt-auto">
                  <div>
                    <h4 className="font-bold">{testimonials[currentIndex].name}</h4>
                    {testimonials[currentIndex].role && (
                      <p className="text-white/70 text-sm">
                        {testimonials[currentIndex].role}
                        {testimonials[currentIndex].company && `, ${testimonials[currentIndex].company}`}
                      </p>
                    )}
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
          
          <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-3">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => {
                  setDirection(index > currentIndex ? 1 : -1);
                  setCurrentIndex(index);
                }}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex ? 'bg-accent w-8' : 'bg-white/30'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;